import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { LoginComponent } from "./login/login.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { AuthGuard } from "./@core/guards/auth.guard";
import { MaintenanceGuard } from "./@core/guards/maintenance-mode.guard";

const routes: Routes = [
  {
    path: "pages",
    loadChildren: "app/pages/pages.module#PagesModule",
    canActivate: [MaintenanceGuard, AuthGuard],
    canActivateChild: [MaintenanceGuard, AuthGuard],
  },
  {
    path: "login",
    component: LoginComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: "maintenance",
    component: MaintenanceComponent,
  },
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "**", redirectTo: "pages" },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  providers: [MaintenanceGuard, AuthGuard],
})
export class AppRoutingModule {}
